// src/shared/audit.js — одит следата в записите (копие от app.js, Фаза 3).
// Чисти функции: legacy копията остават в app.js за немигрираните екрани.

import { el } from './dom.js';

// Дата+час за одит следата.
export function whenFmt(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return String(iso);
  const p = (n) => String(n).padStart(2, '0');
  return p(d.getDate()) + '.' + p(d.getMonth() + 1) + '.' + d.getFullYear() + ' ' + p(d.getHours()) + ':' + p(d.getMinutes());
}

// Кратко описание на устройство/браузър от User-Agent.
export function uaShort(ua) {
  ua = String(ua || '');
  if (!ua) return '';
  let br = 'Браузър';
  if (/Edg\//.test(ua)) br = 'Edge'; else if (/OPR\/|Opera/.test(ua)) br = 'Opera'; else if (/Chrome\//.test(ua)) br = 'Chrome'; else if (/Firefox\//.test(ua)) br = 'Firefox'; else if (/Safari\//.test(ua)) br = 'Safari';
  let os = '';
  if (/Windows/.test(ua)) os = 'Windows'; else if (/Android/.test(ua)) os = 'Android'; else if (/iPhone|iPad|iOS/.test(ua)) os = 'iOS'; else if (/Mac OS X|Macintosh/.test(ua)) os = 'macOS'; else if (/Linux/.test(ua)) os = 'Linux';
  return [br, os].filter(Boolean).join(' · ');
}

// Български имена на полетата от историята по полета (фактури и проформи —
// services/documentLock.js пише машинните ключове, тук стават четими).
const FIELD_LABELS = {
  issue_date: 'Дата на издаване',
  due_date: 'Падеж',
  contact_id: 'Клиент',
  vat_rate: 'ДДС %',
  currency: 'Валута',
  notes: 'Основание / бележки',
  payment_method: 'Начин на плащане',
  status: 'Статус',
  doc_type: 'Тип документ',
  ref_invoice_id: 'Към фактура',
  received_by: 'Получил',
};

function fieldLabel(field) {
  const m = /^items\[(\d+)\]$/.exec(String(field || ''));
  if (m) return 'Ред ' + m[1];
  return FIELD_LABELS[field] || field;
}

// Стойност за показване: екранът може да я преведе (resolve — напр. номер на
// клиент → име); иначе ISO дата става българска, празното — тире.
function histValue(field, v, resolve) {
  if (resolve) {
    const r = resolve(field, v);
    if (r != null) return r;
  }
  if (v == null || v === '') return '—';
  if (/^\d{4}-\d{2}-\d{2}/.test(String(v))) {
    const p = String(v).slice(0, 10).split('-');
    return p[2] + '.' + p[1] + '.' + p[0];
  }
  return String(v);
}

// Един ред от историята, четим: записите ПО ПОЛЕТА стават
// „12.08.2026 14:31 — Иван Петров промени Дата на издаване: 10.08.2026 → 12.08.2026",
// старите (само действие) остават както досега.
export function histLine(h, resolve) {
  if (h && h.field) {
    return whenFmt(h.at) + ' — ' + (h.by || '—') + ' промени ' + fieldLabel(h.field) + ': '
      + histValue(h.field, h.from, resolve) + ' → ' + histValue(h.field, h.to, resolve);
  }
  return whenFmt(h.at) + ' · ' + (h.by || '—') + ' · ' + (h.action || '');
}

// Блок „кой и кога" за фактури/протоколи/чек лист.
// opts.resolve(field, value) — по избор: превод на стойност (връща null,
// когато оставя подразбиращото се форматиране).
export function auditBlock(rec, opts) {
  if (!rec || (!rec.created_at && !(rec.history && rec.history.length))) return null;
  const resolve = (opts && opts.resolve) || null;
  const wrap = el('div', { style: 'margin-top:14px;padding-top:10px;border-top:1px solid var(--border);font-size:12px;color:var(--muted)' });
  if (rec.created_by_name || rec.created_at) wrap.appendChild(el('div', { text: 'Създал: ' + (rec.created_by_name || '—') + (rec.created_at ? ' · ' + whenFmt(rec.created_at) : '') }));
  if (rec.updated_by_name && rec.updated_at) wrap.appendChild(el('div', { text: 'Последна промяна: ' + rec.updated_by_name + ' · ' + whenFmt(rec.updated_at) }));
  const hist = Array.isArray(rec.history) ? rec.history : [];
  if (hist.length) {
    const det = el('details', { style: 'margin-top:6px' }, el('summary', { style: 'cursor:pointer', text: 'История на промените (' + hist.length + ')' }));
    hist.slice().reverse().forEach((h) => det.appendChild(el('div', { style: 'margin:3px 0 0 8px' }, histLine(h, resolve))));
    wrap.appendChild(det);
  }
  return wrap;
}
